import { render, staticRenderFns } from "./TextResponseReport.vue?vue&type=template&id=60afee1a"
import script from "./TextResponseReport.vue?vue&type=script&lang=js"
export * from "./TextResponseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports